import React, { useMemo } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    Card,
    CardMedia,
    Box,
    Button,
    Typography,
    CircularProgress,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import RefreshIcon from "@mui/icons-material/Refresh";

import styles from "./styles/styles.module.scss";

export default function MediaLibraryDialog({
    open,
    onClose,
    search,
    setSearch,
    loading,
    items = [],
    nextCursor,
    onLoadMore,
    onSelectKey,
    toDisplaySrc,
}) {
    const filtered = useMemo(() => {
        const q = String(search || "").trim().toLowerCase();
        if (!q) return items;

        return items.filter((x) => String(x?.key || "").toLowerCase().includes(q));
    }, [items, search]);

    const isEmpty = !loading && filtered.length === 0;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
            <DialogTitle>Бібліотека зображень</DialogTitle>

            <DialogContent>
                <TextField
                    fullWidth
                    placeholder="Пошук по key..."
                    value={search}
                    onChange={(e) => setSearch?.(e.target.value)}
                    sx={{ mb: 2 }}
                />

                {loading && (
                    <Box className={styles.libraryLoader}>
                        <CircularProgress size={22} />
                        <Typography variant="body2" color="text.secondary">
                            Завантаження...
                        </Typography>
                    </Box>
                )}

                {isEmpty && (
                    <Box className={styles.libraryEmpty}>
                        <Typography variant="body2" color="text.secondary">
                            ͳНічого не знайдено
                        </Typography>
                    </Box>
                )}

                <Grid container spacing={1.25}>
                    {filtered.map((item, idx) => {
                        const key = String(item?.key || "");
                        const safeKey = key || `item-${idx}`;
                        const src = toDisplaySrc(key);

                        return (
                            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={safeKey}>
                                <Card
                                    className={styles.card}
                                    onClick={() => key && onSelectKey?.(key)}
                                    title={key}
                                >
                                    <CardMedia
                                        component="img"
                                        image={src}
                                        className={styles.thumb}
                                        sx={{ height: 180 }}
                                    />
                                    <Box className={styles.cardFooter}>
                                        <Typography className={styles.key}>{key}</Typography>
                                    </Box>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>

                {!!nextCursor && (
                    <Box className={styles.loadMore}>
                        <Button
                            startIcon={<RefreshIcon sx={{ color: "#000" }} />}
                            onClick={onLoadMore}
                            disabled={loading}
                            variant="text"
                        >
                            Завантажити ще
                        </Button>
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    );
}